// extracted by mini-css-extract-plugin
export default {"weekday__item":"Weekdays_weekday__item__eDtCz","weekday__item-read":"Weekdays_weekday__item-read__Ha-ma","active":"Weekdays_active__Hs9Mx","blocked":"Weekdays_blocked__UWZI+"};